import { useTranslation } from "react-i18next";
import React, { useState, useEffect, Fragment, useMemo } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import apiRequest from "../../functions/api";
import {
  Paper,
  Typography,
  Table,
  Hidden,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Button,
  Grid,
  TextField,
  MenuItem,
  Card,
  Box,
} from "@mui/material";
import ResponsiveDialog from '../shared/components/ResponsiveDialog'
import DoneIcon from "@mui/icons-material/Done";
import CloseIcon from "@mui/icons-material/Close";
import LoadingComponent from "../LoadingComponent/LoadingComponent";
import { useMessage } from "../../context/message-context";
import { DateToJulian, JulianToDate } from "../../functions/dates";
import { pad } from "../../functions/default";
import moment from "moment";
import "moment/locale/de";
function AbsenceDetails(props) {
  const { t } = useTranslation();
  let { antragid } = useParams();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [antraege, setAntraege] = useState(null);
  const { accessToken, client } = props;
  const [isLoading, setIsLoading] = useState(false);
  const { showErrorMessage, hideMessage } = useMessage();
  const [zeiten, setZeiten] = useState([]);
  const [zkor, setZkor] = useState([]);
  const [zusatzZeiten, setZusatzZeiten] = useState("");
  const [zahlart, setZahlart] = useState(-1);
  const [vglZahlart, setVglZahlart] = useState(-1);
  const [dateList, setDateList] = useState([]);
  const [zeitart, setZeitart] = useState([]);
  const [zeitartFix, setZeitartFix] = useState("");
  const [bem,setBem]=useState(false)
  const [bemerkung,setBemerkung]=useState("")
  const [stornobem,setStornobem]=useState("")
  const [datepast, setDatepast] = useState(
    new Date(new Date().getTime() + 1000 * 60 * 60 * 24 * 1)
      .getFullYear()
      .toString() +
      "-" +
      pad(
        new Date(new Date().getTime() + 1000 * 60 * 60 * 24 * 1).getMonth() + 1,
        2
      ) +
      "-" +
      pad(new Date(new Date().getTime() + 1000 * 60 * 60 * 24 * 1).getDate(), 2)
  );
  const today =
    new Date().getFullYear().toString() +
    "-" +
    pad(new Date().getMonth() + 1, 2) +
    "-" +
    pad(new Date().getDate(), 2);
  const [vglZeiten, setVglZeiten] = useState([]);
  const [meldungdirekt, setMeldungdirekt] = useState(0);

  const {userid, admin} = useMemo(() => {
    if (searchParams && searchParams.get("userId")) {
      return {
        admin: "J",
        userid: searchParams.get("userId")
      }
    } else {
      return {
        admin: "",
        userid: ""
      };
    }
  }, [searchParams]);

  useEffect(() => {
    setIsLoading(true);
    const payload = {
      mandant: client,
      program: admin === "J" ? "PMURB3" : "PMURA1",
      statement: "DETAILS",
      absence: antragid,
      vgmode: admin,
      id: userid,
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    apiRequest("POST", "daten", payload, headers, antragCb);
    // eslint-disable-next-line
  }, []);
  const antragCb = (response) => {
    if (response.status === 200) {
      setAntraege(response.data.antraege);
      setZusatzZeiten(response.data.zusatz_zeiten);
      setZkor(response.data.zkor);
      setDatepast(response.data.datepast);
      setStornobem(response.data.stornobem)
      setMeldungdirekt(response.data.meldungdirekt);
      if (response.data.antraege.zahlart) {
        setZahlart(response.data.antraege.zahlart);
        setVglZahlart(response.data.antraege.zahlart);
      } else {
        if (response.data.zkor && response.data.zkor.length === 1) {
          setZahlart(0);
          setVglZahlart(0);
        }
      }
      if (response.data.ZEITART) {
        setZeitart(response.data.ZEITART);
      }
      if (response.data.zeitart_fix) {
        setZeitartFix(response.data.zeitart_fix);
      }

      if (response.data.antraege.zeiten) {
        setZeiten(response.data.antraege.zeiten);
        setVglZeiten(JSON.parse(JSON.stringify(response.data.antraege.zeiten)));
      }
      DateList(response.data.antraege.vondat2, response.data.antraege.bisdat2);
      setIsLoading(false);
      hideMessage();
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  };

  function Storno(art){
    if (antraege.vdatinv < datepast){
      showErrorMessage(t("Es können keine Abwesenheiten, die vor dem " +
      datepast.substr(6, 2) +
      "." +
      datepast.substr(4, 2) +
      "." +
      datepast.substr(0, 4) +
      " liegen, storniert werden"));
      return;
    }
    if (stornobem==="1" || stornobem==="2"){
      setBem(true)
    } else {
      aufgabeaktion("STORNIEREN",antraege.art)
    }
    
  }


  const aufgabeaktion = (aktion, art) => {
    if (
      zeiten &&
      zeiten.length > 0 &&
      zkor &&
      zkor.length > 0 &&
      zahlart === -1
    ) {
      showErrorMessage(t("Bitte wählen Sie eine Vergütungsart aus"));
      return;
    }

    setIsLoading(true);
    const payload = {
      mandant: client,
      program: admin === "J" ? "PMURB3" : "PMURA1",
      statement: "DETAILS_AKTION",
      absence: antragid,
      aktion: aktion,
      art: art,
      vgmode: admin,
      id: userid,
      bemerkung:bemerkung,
      FELD: {
        ZAHLART: zahlart > -1 ? zkor[zahlart].key : "",
        ZEITEN: zeiten && zeiten.length > 0 ? zeiten : [],
      },
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    apiRequest("POST", "daten", payload, headers, aktionCB);
  };
  const aktionCB = (response) => {
    setIsLoading(false);
    if (response.status === 200) {
      hideMessage();
      navigate(-1);
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  };
  function DateList(vondat, bisdat) {
    var startDate = vondat;
    var endDate = bisdat;
    var tmplist = [];
    var tmpvon = DateToJulian(
      new Date(
        startDate.substr(0, 4),
        (Number(startDate.substr(5, 2)) - 1).toString(),
        startDate.substr(8, 2)
      )
    );
    var tmpbis = DateToJulian(
      new Date(
        endDate.substr(0, 4),
        (Number(endDate.substr(5, 2)) - 1).toString(),
        endDate.substr(8, 2)
      )
    );
    var tmptoday = DateToJulian(
      new Date(
        today.substr(0, 4),
        (Number(today.substr(5, 2)) - 1).toString(),
        today.substr(8, 2)
      )
    );
    for (var i = tmpvon; i <= tmpbis; i++) {
      if (i <= tmptoday) {
        var tmpdate = JulianToDate(i);
        var tmpdaterev = moment(
          tmpdate.getFullYear().toString() +
            "-" +
            pad(tmpdate.getMonth() + 1, 2) +
            "-" +
            pad(tmpdate.getDate(), 2)
        );
        var day = tmpdaterev.day();
        var daybez = "";
        if (day === 1) daybez = "Montag";
        if (day === 2) daybez = "Dienstag";
        if (day === 3) daybez = "Mittwoch";
        if (day === 4) daybez = "Donnerstag";
        if (day === 5) daybez = "Freitag";
        if (day === 6) daybez = "Samstag";
        if (day === 0) daybez = "Sonntag";
        tmpdate =
          pad(tmpdate.getDate(), 2) +
          "." +
          pad(tmpdate.getMonth() + 1, 2) +
          "." +
          tmpdate.getFullYear().toString() +
          " - " +
          daybez;
        tmplist.push(tmpdate);
      }
    }
    setDateList(tmplist);
  }
  function NewLine() {
    var tmpliste = [...zeiten];
    tmpliste.push({
      taglfd: "",
      zeitlfd: "",
      vzeit: "00:00",
      bzeit: "00:00",
      datum: "",
      datum2: "",
      za_key: zeitartFix,
    });
    setZeiten(tmpliste);
  }
  function ChangeZeiten(val, op, index) {
    var tmpliste = [];
    if (op === "datum") {
      tmpliste = [...zeiten];
      tmpliste[index].datum = val;
    }
    if (op === "vonzeit") {
      tmpliste = [...zeiten];
      tmpliste[index].vzeit = val;
    }
    if (op === "biszeit") {
      tmpliste = [...zeiten];
      tmpliste[index].bzeit = val;
    }
    if (op === "del") {
      tmpliste = [];
      zeiten.forEach((item, index2) => {
        if (index !== index2)
          tmpliste.push({
            taglfd: item.taglfd,
            zeitlfd: item.zeitlfd,
            vzeit: item.vzeit,
            bzeit: item.bzeit,
            datum: item.datum,
            datum2: item.datum2,
            za_key: item.za_key
          });
      });
    }
    setZeiten(tmpliste);
  }
  if (isLoading) {
    return <LoadingComponent />;
  }
  if (!antraege) {
    return (
      <Typography color="primary" variant="h5">
        {t("Antrag konnte nicht gefunden werden")}
      </Typography>
    );
  }
  return (
    <div>
      <ResponsiveDialog
        title={t("Grund")} 
        open={bem} 
        setOpen={() => {setBem(false)}}
        actionButton={    
          <Fragment>
            <Grid container spacing={2} justifyContent="flex-end">
              <Grid item>
                <Button  variant="outlined" color="primary" onClick={() => {setBem(false)}}>{t("Abbrechen")}</Button>
              </Grid>
              
              <Grid item>
                <Button  disabled={stornobem==="2"&&bemerkung.replace(/\s+/g, '')===""} variant="outlined" color="primary" onClick={() => {setBem(false);aufgabeaktion("STORNIEREN",antraege.art)}}>{t("Absenden")}</Button>
              </Grid>
        
            </Grid>
          </Fragment>  
        }
      >
        <Box p={2}>
          <Grid container justifyContent="center" spacing={2}>
            <Grid item xs={10}>
            <TextField
                  id="comment"
                  label={t("Grund für die Stornierung")}
                  multiline
                  fullWidth
                  helperText={bemerkung.length + "/200"}
                  value={bemerkung}
                  inputProps={{ maxLength: 200 }}
                  onChange={(e) => setBemerkung(e.target.value)}
                  variant="outlined"
                />
            </Grid>
          </Grid>
        </Box>
      </ResponsiveDialog>
      <Grid container justifyContent="center">
        <Grid item xs={12} md={8}>
          <Grid container justifyContent="center" spacing={2}>
            <Hidden smDown>
              <Grid item>
                <Typography color="primary" variant="h5">
                  {t("Antragsdetails")}
                </Typography>
              </Grid>
            </Hidden>
            <Grid item xs={12}>
              <TableContainer component={Paper}>
                <Table>
                  <TableBody>
                    <TableRow>
                      <TableCell>{t("Ausgewählte Abwesenheit")}</TableCell>
                      <TableCell>{antraege.fzbez}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>{t("Status")}</TableCell>
                      <TableCell>{antraege.statustext}</TableCell>
                    </TableRow>
                    
                      <TableRow>
                        <TableCell>{t("Beantragt am")}</TableCell>
                        <TableCell>
                          {antraege.antragdat}
                        </TableCell>
                      </TableRow>
                    
                    {antraege.von && (
                      <TableRow>
                        <TableCell>{t("Bearbeitet von")}</TableCell>
                        <TableCell>
                          {antraege.von + " am " + antraege.vondat}
                        </TableCell>
                      </TableRow>
                    )}
                    <TableRow>
                      <TableCell>{t("Von Datum")}</TableCell>
                      <TableCell>{antraege.vdat}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>{t("Bis Datum")}</TableCell>
                      <TableCell>{antraege.bdat}</TableCell>
                    </TableRow>
                    {antraege.vzeit && (
                      <TableRow>
                        <TableCell>{t("Von Zeit")}</TableCell>
                        <TableCell> {antraege.vzeit} </TableCell>
                      </TableRow>
                    )}
                    {antraege.bzeit && (
                      <TableRow>
                        <TableCell>{t("Bis Zeit")}</TableCell>
                        <TableCell> {antraege.bzeit} </TableCell>
                      </TableRow>
                    )}
                    {antraege.hinwan !== "" && (
                      <TableRow>
                        <TableCell>{t("Bemerkung (Antragsteller)")}</TableCell>
                        <TableCell> {antraege.hinwan} </TableCell>
                      </TableRow>
                    )}
                     {antraege.stornobem !== "" && (
                      <TableRow>
                        <TableCell>{t("Bemerkung der Stornierung (Antragsteller)")}</TableCell>
                        <TableCell> {antraege.stornobem} </TableCell>
                      </TableRow>
                    )}
                    {antraege.vertreter_name && (
                      <TableRow>
                        <TableCell>{t("Vertreter")}</TableCell>
                        <TableCell> {antraege.vertreter_name} </TableCell>
                      </TableRow>
                    )}
                    {antraege.proz && (
                      <TableRow>
                        <TableCell>{t("Auszahlungsprozent")}</TableCell>
                        <TableCell> {antraege.proz} </TableCell>
                      </TableRow>
                    )}
                    {antraege.fzeit && (
                      <TableRow>
                        <TableCell>{t("Fahrtzeit")}</TableCell>
                        <TableCell> {antraege.fzeit} </TableCell>
                      </TableRow>
                    )}
                    {antraege.reisegrund && (
                      <TableRow>
                        <TableCell>{t("Reisegrund")}</TableCell>
                        <TableCell> {antraege.reisegrund} </TableCell>
                      </TableRow>
                    )}
                    {antraege.reiseland && (
                      <TableRow>
                        <TableCell>{t("Reiseland")}</TableCell>
                        <TableCell> {antraege.reiseland} </TableCell>
                      </TableRow>
                    )}
                    {antraege.reiseort && (
                      <TableRow>
                        <TableCell>{t("Reiseort")}</TableCell>
                        <TableCell> {antraege.reiseort} </TableCell>
                      </TableRow>
                    )}
                    {antraege.reisevkm && (
                      <TableRow>
                        <TableCell>{t("Reise Verkehrsmittel")}</TableCell>
                        <TableCell> {antraege.reisevkm} </TableCell>
                      </TableRow>
                    )}
                    {antraege.zeiten &&
                      antraege.zeiten.length > 0 &&
                      antraege.zeiten.map((item, index) => (
                        <TableRow>
                          <TableCell>{t("Zeit Buchung")}</TableCell>
                          <TableCell>
                            {item.datum2 +
                              "    " +
                              item.vzeit +
                              " - " +
                              item.bzeit}
                          </TableCell>
                        </TableRow>
                      ))}
                    {antraege.zahlart2 && antraege.zahlart2 !== "00" && (
                      <TableRow>
                        <TableCell>{t("Vergütungsart")}</TableCell>
                        <TableCell> {antraege.zahlart2} </TableCell>
                      </TableRow>
                    )}
                    {antraege.hinwvg && (
                      <TableRow>
                        <TableCell>{t("Hinweistext Vorgesetzter")}</TableCell>
                        <TableCell> {antraege.hinwvg} </TableCell>
                      </TableRow>
                    )}
                    {antraege.hinwsb && (
                      <TableRow>
                        <TableCell>{t("Hinweistext Personal")}</TableCell>
                        <TableCell> {antraege.hinwsb} </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
            {zusatzZeiten === "J" && (
              <Grid item xs={12}>
                <Card>
                  <Box p={2}>
                    <Grid container justifyContent="center" spacing={2}>
                      <Grid item xs={12}>
                        <Typography color="primary" variant="h5">
                          {t("Zeiten bearbeiten")}
                        </Typography>
                      </Grid>
                      {zeiten &&
                        zeiten.map((zeit, index) => (
                          <Fragment>
                            <Grid item xs={12}>
                              <hr align="center" width="100%" />
                            </Grid>
                            <Grid item xs={12}>
                              <TextField
                                size="small"
                                id={"datum" + index}
                                label={t("Datum")}
                                select
                                fullWidth
                                //disabled={(active !== null && requests[active].status !=="0"&& requests[active].status !=="7") ? true : false}
                                value={zeit.datum}
                                onChange={(e) => {
                                  zeit.datum = e.target.value;
                                  setZeiten([...zeiten]);
                                }}
                                variant="outlined"
                              >
                                {dateList.map((date, index) => (
                                  <MenuItem key={index} value={date}>
                                    {date}
                                  </MenuItem>
                                ))}
                              </TextField>
                            </Grid>
                            {(zeitart&&zeitart.length)>0&&
                            <Grid item xs={12}>
                              <TextField
                                size="small"
                                id={"za" + index}
                                label={t("Zeitart")}
                                select
                                fullWidth
                                //disabled={(active !== null && requests[active].status !=="0"&& requests[active].status !=="7") ? true : false}
                                value={zeit.za_key}
                                onChange={(e) => {
                                  zeit.za_key = e.target.value;
                                  setZeiten([...zeiten]);
                                }}
                                variant="outlined"
                              >
                                {zeitart.map((zeita, index) => (
                                  <MenuItem key={zeita.KEY} value={zeita.KEY}>
                                    {zeita.BEZ}
                                  </MenuItem>
                                ))}
                              </TextField>
                            </Grid>
                            
                                }
                            <Grid item xs={12}>
                              <TextField
                                size="small"
                                id={"von" + index}
                                label={t("Von Zeit")}
                                type="time"
                                fullWidth
                                //disabled={(active !== null && requests[active].status !=="0"&& requests[active].status !=="7") ? true : false}
                                onChange={(e) => {
                                  zeit.vzeit = e.target.value;
                                  setZeiten([...zeiten]);
                                }}
                                value={zeit.vzeit}
                                variant="outlined"
                                ä
                                InputLabelProps={{
                                  shrink: true,
                                }}
                              />
                            </Grid>
                            <Grid item xs={12}>
                              <TextField
                                size="small"
                                id={"bis" + index}
                                label={t("Bis Zeit")}
                                type="time"
                                fullWidth
                                //disabled={(active !== null && requests[active].status !=="0"&& requests[active].status !=="7") ? true : false}
                                onChange={(e) => {
                                  zeit.bzeit = e.target.value;
                                  setZeiten([...zeiten]);
                                }}
                                value={zeit.bzeit}
                                variant="outlined"
                                InputLabelProps={{
                                  shrink: true,
                                }}
                              />
                            </Grid>
                            <Grid item xs={12}>
                              <Button
                                variant="contained"
                                color="primary"
                                onClick={() => ChangeZeiten("", "del", index)}
                              >
                                {t("Arbeitszeit entfernen")}
                              </Button>
                            </Grid>
                          </Fragment>
                        ))}
                      <Fragment>
                        <Grid item xs={12}>
                          <Button
                            variant="contained"
                            color="primary"
                            onClick={() => NewLine()}
                          >
                            {t("Arbeitszeit hinzufügen")}
                          </Button>
                        </Grid>
                      </Fragment>
                      {(zkor && zkor.length > 0 && zeiten && zeiten.length) >
                        0 && (
                        <Fragment>
                          <Grid item xs={12}>
                            <TextField
                              size="small"
                              id="Vergütungsart"
                              label={t("Vergütungsart")}
                              select
                              fullWidth
                              disabled={zkor && zkor.length === 1}
                              value={zahlart}
                              onChange={(e) => setZahlart(e.target.value)}
                              variant="outlined"
                            >
                              {zkor &&
                                zkor.length > 0 &&
                                zkor.map((item, index) => (
                                  <MenuItem key={index} value={index}>
                                    {item.bez}
                                  </MenuItem>
                                ))}
                            </TextField>
                          </Grid>
                        </Fragment>
                      )}
                    </Grid>
                  </Box>
                </Card>
              </Grid>
            )}
            {antraege.kenntnis === "N" && admin !== "J" && (
              <Grid item xs={12} sm={6} md={3}>
                <Button
                  fullWidth
                  variant="contained"
                  color="primary"
                  startIcon={<DoneIcon />}
                  onClick={() => aufgabeaktion("KENNTNIS", antraege.art)}
                >
                  {t("Zur Kenntnis nehmen")}
                </Button>
              </Grid>
            )}
            {antraege.status === "1" && antraege.art !== "M" && (
              <Grid item xs={12} sm={6} md={3}>
                <Button
                  fullWidth
                  variant="contained"
                  color="primary"
                  startIcon={<CloseIcon />}
                  onClick={() => Storno(antraege.art)}
                >
                  {t("Stornieren")}
                </Button>
              </Grid>
            )}
            {antraege.status === "0" && antraege.art === "M" && (
              <Grid item xs={12} sm={6} md={3}>
                <Button
                  fullWidth
                  variant="contained"
                  color="primary"
                  startIcon={<CloseIcon />}
                  onClick={() => aufgabeaktion("ENTFERNEN", antraege.art)}
                >
                  {t("Meldung entfernen")}
                </Button>
              </Grid>
            )}
            {antraege.status === "1" &&
              antraege.art === "M" &&
              (meldungdirekt === "1" || meldungdirekt === "2") && (
                <Grid item xs={12} sm={6} md={3}>
                  <Button
                    fullWidth
                    variant="contained"
                    color="primary"
                    startIcon={<CloseIcon />}
                    onClick={() => aufgabeaktion("ENTFERNEN", antraege.art)}
                  >
                    {t("Meldung zurückziehen")}
                  </Button>
                </Grid>
              )}
            {(antraege.status === "2" ||
              antraege.status === "4" ||
              antraege.status === "5") && (
                <Grid item xs={12} sm={6} md={3}>
                  <Button
                    fullWidth
                    variant="contained"
                    color="primary"
                    startIcon={<CloseIcon />}
                    onClick={() => aufgabeaktion("ENTFERNENABL", antraege.art)}
                  >
                    {t("Entfernen")}
                  </Button>
                </Grid>
              )}
            {antraege.status === "3" && (
              <Grid item xs={12} sm={6} md={3}>
                <Button
                  fullWidth
                  variant="contained"
                  color="primary"
                  startIcon={<CloseIcon />}
                  onClick={() => aufgabeaktion("DESTORNO", antraege.art)}
                >
                  {t("Storno zurücknehmen")}
                </Button>
              </Grid>
            )}
            {zusatzZeiten === "J" &&
              (JSON.stringify(zeiten) !== JSON.stringify(vglZeiten) ||
                (zeiten.length > 0 && zahlart !== vglZahlart)) && (
                <Fragment>
                  <Grid item xs={12} sm={6} md={3}>
                    <Button
                      fullWidth
                      variant="contained"
                      color="primary"
                      startIcon={<DoneIcon />}
                      onClick={() => aufgabeaktion("BEARBEITEN", antraege.art)}
                    >
                      {t("Änderungen absenden")}
                    </Button>
                  </Grid>
                </Fragment>
              )}
            {zusatzZeiten === "J" &&
              (JSON.stringify(zeiten) !== JSON.stringify(vglZeiten) ||
                (zeiten.length > 0 && zahlart !== vglZahlart)) && (
                <Fragment>
                  <Grid item xs={12} sm={6} md={3}>
                    <Button
                      fullWidth
                      variant="contained"
                      color="primary"
                      startIcon={<DoneIcon />}
                      onClick={() => aufgabeaktion("VORMERKEN", antraege.art)}
                    >
                      {t("Änderungen vormerken")}
                    </Button>
                  </Grid>
                </Fragment>
              )}
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}
export default AbsenceDetails;
